import { create } from 'zustand';
import { persist } from 'zustand/middleware';


interface AppState {
    isDrawerMenuOpen: boolean;
    isCoursesFilterOpen: boolean;
    changeDrawerMenuState: (state: boolean) => void;
    setCoursesFilterOpen: (state: boolean) => void;
    backButtonPath: string;
    setBackButtonPath: (path: string) => void;
    loading: boolean;
    setLoading: (loading: boolean) => void;
}

export const useAppState = create<AppState>()(
    persist(
        (set, get) => ({
          backButtonPath: sessionStorage.getItem('backButtonPath') || '',
          setBackButtonPath: (path) => {
            sessionStorage.setItem('backButtonPath', path);
            set({backButtonPath: path});
          },
          loading: false,
          setLoading: (loading) => set({loading}),
            isDrawerMenuOpen: false,
            isCoursesFilterOpen: false,
            changeDrawerMenuState: (state) => set({
                isDrawerMenuOpen: state
            }),
          setCoursesFilterOpen: (state) => set({
                isCoursesFilterOpen: state
            }),
        }),
        {
            name: 'app-storage',
            version: 1,
            // Only persist choices, not the current step
            partialize: (state) => ({
                isDrawerMenuOpen: state.isDrawerMenuOpen
            }),
        }
    )
);
